export const CREDENTIALS = {
    PRODUCTION: 'S2V5VHJhdmVsX3ByZDpCN3loNExybjEwUnJSSXlKcEx2Nw==',
    TEST: 'S2V5VHJhdmVsX3BkdDpCN3loNExybjEwUnJSSXlKcEx2Nw==',
};

const ENPOINT = {
    TEST_BWS: 'https://testbws.amadeus.com',
    KEY_TRAVEL_TEST_BWS: 'https://key-travel-testbws.amadeus-cloud.de',
    PRODUCTION: 'https://bws.amadeus.com',
};

export default {
    timeout: 180000,
    clientId: 'Workshop07122016',
    credentials: CREDENTIALS.PRODUCTION,
    serviceVersion: 'V2.2',
    base: ENPOINT.PRODUCTION,
};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/flight-seatmap-config.js